<template>
    <form-row title="Has Your Inspection Report Been Sent to the Appropriate Party?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="inspection_report_sent"
                v-model="inspection_report_sent"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="inspection_report_sent"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Sent:"
                :value="inspection.inspection_report_sent_at"
                name="inspection_report_sent_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        inspection: {},
        read_only: { default: false },
    },

    data() {
        return {
            inspection_report_sent: this.inspection.inspection_report_sent,
        }
    },
}
</script>
